import i18next from 'i18next';
import React from 'react';
import en from './i18n/en';
import ptBr from './i18n/pt-br';

i18next.addResourceBundle('pt-br', 'despesa/cadastro/imposto', ptBr);
i18next.addResourceBundle('en', 'despesa/cadastro/imposto', en);

const ImpostoConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/financeiro/imposto',
      component: React.lazy(() => import('./Imposto')),
    },
  ],
};

export default ImpostoConfig;
